import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _geDoneWorksCalculationMaterialsMetrics(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		options
	)
}
function _getDoneWorksCalculationMaterialsMetricPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_PREVIEW,
		options
	)
}
function _getDoneWorksCalculationMaterialsMetricPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_POPUP,
		options
	)
}

function _createDoneWorksCalculationMaterialsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].CREATE_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
		options
	)
}

function _getDoneWorksCalculationMaterialsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
		options
	)
}

function _patchDoneWorksCalculationMaterialsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
		options
	)
}

function _patchDoneWorksCalculationMaterialsMetricBulkUpdate(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC_BULK_UPDATE,
		options
	)
}

function _putDoneWorksCalculationMaterialsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PUT_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
		options
	)
}

function _deleteDoneWorksCalculationMaterialsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].DELETE_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRICS]: _geDoneWorksCalculationMaterialsMetrics,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_PREVIEW]: _getDoneWorksCalculationMaterialsMetricPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_POPUP]: _getDoneWorksCalculationMaterialsMetricPopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].CREATE_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: _createDoneWorksCalculationMaterialsMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: _getDoneWorksCalculationMaterialsMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: _patchDoneWorksCalculationMaterialsMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC_BULK_UPDATE]: _patchDoneWorksCalculationMaterialsMetricBulkUpdate,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PUT_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: _putDoneWorksCalculationMaterialsMetric,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].DELETE_DONE_WORKS_CALCULATION_MATERIALS_METRIC]: _deleteDoneWorksCalculationMaterialsMetric,
}